import './New.sass'

const New = () => {
  return (
    <div className='new'>New</div>
  )
}

export default New